<template>
  <div data-tour-id="samples-register-shipping-panel">
    <div class="input-full">
      <div>
        <div class="card-content padding">
          <div class="form-container">
            <form>
              <div class="header">
                <p>
                  <i class="fas fa-shipping-fast"></i>
                  <b>{{ $t('independentShipping') }}</b>
                </p>
              </div>
              <DxForm
                :form-data="formDataCheck"
                :col-count="1"
                label-location="top"
              >
                <DxItem
                  editor-type="dxCheckBox"
                  data-field="AgenciaAjena"
                  :label="{ visible: false }"
                  :editor-options="{
                    text: $t('independentShippingMessage'),
                  }"
                />
              </DxForm>

              <div class="header">
                <br />
                <p>
                  <i class="fas fa-box"></i>
                  <b>{{ $t('shippingData') }}</b>
                </p>
              </div>
              <DxForm
                label-location="top"
                :col-count="4"
                :form-data="formData"
                :show-colon-after-label="false"
              >
                <DxGroupItem
                  :visible="!formDataCheck.AgenciaAjena"
                  :col-count="2"
                  :col-span="4"
                >
                  <DxItem
                    data-field="Agencia"
                    editor-type="dxSelectBox"
                    :is-required="true"
                    :editor-options="{
                      disabled: false,
                      dataSource: store,
                      displayExpr: 'AgenciaPais',
                      searchEnabled: true,
                      valueExpr: 'idAgencia',
                    }"
                    :col-span="1"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel :text="$t('courier_agency')" />
                  </DxItem>
                  <DxItem
                    editor-type="dxDateBox"
                    data-field="shippingDate"
                    :is-required="true"
                    :editor-options="{
                      type: 'date',
                      displayFormat: $helpers.getDateFormat(company),
                      min: invoiceMin, // <<< ahora viene de invoiceSamples
                      invalidDateMessage:
                        $t('invalidDate') || 'Fecha no válida',
                    }"
                    :col-span="2"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                      {
                        type: 'range',
                        min: invoiceMin,
                        message:
                          $t('dateMustBeAfterSampling') ||
                          'La fecha de envío no puede ser anterior a la última Fecha de Muestreo',
                      },
                    ]"
                  >
                    <DxLabel :text="$t('shipping_date')" />
                  </DxItem>
                </DxGroupItem>
                <DxGroupItem
                  :visible="formDataCheck.AgenciaAjena"
                  :col-count="2"
                  :col-span="4"
                >
                  <DxItem
                    data-field="AgenciaLiteral"
                    editor-type="dxTextBox"
                    :is-required="true"
                    :editor-options="{
                      disabled: false,
                      maxLength: 50,
                    }"
                    :col-span="1"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel :text="$t('courier_agency')" />
                  </DxItem>
                  <DxItem
                    editor-type="dxDateBox"
                    data-field="shippingDate"
                    :is-required="true"
                    :editor-options="{
                      type: 'date',
                      displayFormat: $helpers.getDateFormat(company),
                    }"
                    :col-span="2"
                    :validation-rules="[
                      {
                        type: 'required',
                        message: $t('fillRequiredFields'),
                      },
                    ]"
                  >
                    <DxLabel :text="$t('shipping_date')" />
                  </DxItem>
                </DxGroupItem>

                <DxGroupItem
                  :visible="!formDataCheck.AgenciaAjena"
                  :col-count="3"
                  :col-span="4"
                >
                  <DxItem
                    editor-type="dxTextBox"
                    data-field="telefono"
                    :editor-options="{
                      disabled: false,
                      readOnly: true,
                    }"
                  >
                    <DxLabel :text="$t('phone')" />
                  </DxItem>
                  <DxItem
                    editor-type="dxTextBox"
                    data-field="horario"
                    :editor-options="{
                      disabled: false,
                      readOnly: true,
                    }"
                  >
                    <DxLabel :text="$t('Schedule')" />
                  </DxItem>

                  <DxItem
                    editor-type="dxTextBox"
                    data-field="web"
                    :editor-options="{
                      disabled: false,
                      readOnly: true,
                    }"
                  >
                    <DxLabel :text="$t('webSite')" />
                  </DxItem>
                </DxGroupItem>
                <DxItem
                  data-field="observations"
                  editor-type="dxTextArea"
                  :col-span="4"
                >
                  <DxLabel :text="$t('observations')" />
                </DxItem>
                <DxItem
                  :col-span="4"
                  editor-type="dxTextBox"
                  data-field="orderNumber"
                  :editor-options="{ maxLength: 50 }"
                >
                  <DxLabel :text="$t('purchase_order')" />
                </DxItem>
              </DxForm>

              <div
                v-if="showColombiaResponsibility"
                class="colombia-responsibility-row"
              >
                <DxCheckBox
                  :value="
                    formDataCheck
                      .AceptacionResponsabilidadesColombia
                  "
                  :text="
                    $t(
                      'samplesRegister.colombiaResponsibilityMessage'
                    )
                  "
                  @value-changed="
                    formDataCheck.AceptacionResponsabilidadesColombia =
                      $event.value
                  "
                />
              </div>

              <!-- Nueva sección para el campo de Orden de Compra -->
              <!-- <div class="OrderNumberSection">
              <div class="buyorder">
                <p>{{ $t('purchase_order') }}</p>
              </div>
              <div class="OrderNumberField">
                <OrderNumberField />
              </div>
            </div> -->

              <!-- Mensaje de penalización y botón -->
              <div class="PenalityAndButton">
                <PenalityMessage class="penality padding" />
                <div class="button-wrapper">
                  <f7-button
                    class="confirm-btn"
                    data-tour-id="samples-register-confirm-shipping-button"
                    fill
                    outline
                    type="default"
                    name="updateInvoices"
                    @click="$emit('confirm-invoice')"
                  >
                    {{ $t('confirmShipping') }}
                  </f7-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxItem,
  DxLabel,
  DxGroupItem,
} from 'devextreme-vue/form';
import DxCheckBox from 'devextreme-vue/check-box';
import EventBus from '@/services/event-bus';
// import OrderNumberField from '@/components/SamplesRegister/SamplesConfirmation/OrderNumberField.vue';
import PenalityMessage from '@/components/SamplesRegister/PenalityMessage/index.vue';

import { mapState } from 'vuex';

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxGroupItem,
    DxCheckBox,
    // OrderNumberField,
    PenalityMessage,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formDataCheck: {
        AgenciaAjena: false,
        AceptacionResponsabilidadesColombia: false,
      },
      formData: {
        idAlbaran: null,
        CodAlbaran: null,
        CodCliente: null,
        Agencia: null,
        AgenciaLiteral: null,
        shippingDate: null,
        observations: null,
        orderNumber: null,
        telefono: null,
        horario: null,
        web: null,
      },
    };
  },
  computed: {
    ...mapState('contact', ['company']),
    ...mapState('samplesRegisterModule', [
      'SamplingDate',
      'invoiceSamples',
    ]),
    // Fallback anterior: SamplingDate normalizada
    samplingMin() {
      return this.normalizeDate(this.SamplingDate);
    },
    // NUEVO: mínimo permitido = máxima FechaMuestreo en invoiceSamples
    invoiceMin() {
      if (
        !Array.isArray(this.invoiceSamples) ||
        this.invoiceSamples.length === 0
      ) {
        return this.samplingMin;
      }
      const fechas = this.invoiceSamples
        .map((it) => this.normalizeDate(it?.FechaMuestreo))
        .filter(Boolean);
      if (fechas.length === 0) return this.samplingMin;
      return fechas.reduce(
        (max, d) => (max && max > d ? max : d),
        null
      );
    },
    isColombiaClient() {
      return String(this.company || '')
        .trim()
        .toUpperCase()
        .startsWith('CO');
    },
    showColombiaResponsibility() {
      return this.isColombiaClient;
    },
  },
  watch: {
    'formDataCheck.AgenciaAjena': async function () {
      // Si cambia el tipo de agencia, reiniciar campos auxiliares
      this.formData.Agencia = null;
      this.formData.AgenciaLiteral = null;
      this.formData.telefono = null;
      this.formData.horario = null;
      this.formData.web = null;
    },
    'formData.Agencia': async function (idAgencia) {
      this.getAgenciesInfo(idAgencia);
    },
    // Si cambia SamplingDate (fallback), valida contra invoiceMin (que ya usa el fallback)
    SamplingDate: {
      immediate: true,
      handler() {
        const min = this.invoiceMin;
        if (!this.formData.shippingDate) return;
        const actual = this.normalizeDate(this.formData.shippingDate);
        if (min && actual && actual < min) {
          this.formData.shippingDate = min;
        }
      },
    },
    // NUEVO: observar cambios en invoiceSamples para recalcular y corregir
    invoiceSamples: {
      immediate: true,
      deep: true,
      handler() {
        const min = this.invoiceMin;
        const actual = this.normalizeDate(this.formData.shippingDate);
        if (!actual && min) {
          // Autoprellena si está vacío
          this.formData.shippingDate = min;
          return;
        }
        if (min && actual && actual < min) {
          this.formData.shippingDate = min;
        }
      },
    },
    formDataCheck: {
      handler() {
        if (!this.showColombiaResponsibility) {
          this.formDataCheck.AceptacionResponsabilidadesColombia = false;
        }
        EventBus.$emit('formData3', {
          ...this.formData,
          checkAgenciaAjena: this.formDataCheck.AgenciaAjena,
          AceptacionResponsabilidadesColombia:
            this.showColombiaResponsibility &&
            this.formDataCheck.AceptacionResponsabilidadesColombia ===
              true,
        });
      },
      deep: true,
    },
    formData: {
      handler(FormData) {
        // Añade flag para el submit
        const dataToEmit = {
          ...FormData,
          checkAgenciaAjena: this.formDataCheck.AgenciaAjena,
          AceptacionResponsabilidadesColombia:
            this.showColombiaResponsibility &&
            this.formDataCheck.AceptacionResponsabilidadesColombia ===
              true,
        };
        EventBus.$emit('formData3', dataToEmit);
      },
      deep: true,
    },
  },
  methods: {
    getAgenciesInfo(idAgencia) {
      const agencieFiltered = this.store.filter((agencie) => {
        return agencie.idAgencia === idAgencia;
      });
      if (agencieFiltered.length > 0) {
        this.formData.telefono = agencieFiltered[0].Telefono;
        this.formData.horario = agencieFiltered[0].Horario;
        this.formData.web = agencieFiltered[0].Web;
      }
    },
    normalizeDate(v) {
      if (!v) return null;
      const d = v instanceof Date ? new Date(v) : new Date(String(v));
      if (isNaN(d.getTime())) return null;
      d.setHours(0, 0, 0, 0);
      return d;
    },
  },
  created() {
    // Opcional: inicializa shippingDate con el mínimo calculado si está vacío
    if (!this.formData.shippingDate && this.invoiceMin) {
      this.formData.shippingDate = this.invoiceMin;
    }
    EventBus.$emit('formData3', {
      ...this.formData,
      checkAgenciaAjena: this.formDataCheck.AgenciaAjena,
      AceptacionResponsabilidadesColombia: false,
    });
  },
};
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.1/css/all.min.css');

/* Nuevos estilos para la sección de Orden de Compra */
.OrderNumberSection {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.OrderNumberSection .buyorder {
  flex-basis: 150px;
  white-space: nowrap;
}

.OrderNumberSection .OrderNumberField {
  flex-grow: 1;
}

/* Estilos para el mensaje de penalización y el botón */
.PenalityAndButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.PenalityAndButton .penality {
  margin-bottom: 0;
  flex: 1;
}

.PenalityAndButton .color-green {
  margin-left: 0 !important;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  max-width: 240px;
}

.colombia-responsibility-row {
  margin: 12px 0 18px;
}

.colombia-responsibility-row :deep(.dx-checkbox) {
  display: flex;
  align-items: flex-start;
  width: 100%;
  color: #00346a;
}

.colombia-responsibility-row :deep(.dx-checkbox-container) {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.colombia-responsibility-row :deep(.dx-checkbox-icon) {
  flex: 0 0 auto;
  margin-top: 2px;
  border: 2px solid #00346a;
  border-radius: 4px;
  background: #fff;
}

.colombia-responsibility-row :deep(.dx-checkbox-text) {
  flex: 1 1 auto;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.45;
}

.confirm-btn {
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--Basic-White, #fff);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
  border-radius: 10px;
  background: var(--Primary-Blue-70, #00346a);
}
</style>

<style
  scoped
  lang="sass"
  src="./SamplesConfirmationTable.styles.scss"
></style>
